export const validateReturnToUrl = (url: string): boolean => {
	const value = String(url || "").trim();
	if (!value) return false;

	try {
		const currentOrigin =
			typeof window !== "undefined" && window.location?.origin ? window.location.origin : "https://cerebrum.com";
		const { hostname, origin, protocol } = new URL(value, currentOrigin);
		if (protocol !== "http:" && protocol !== "https:") return false;
		return origin === currentOrigin || hostname === "cerebrum.com" || hostname.endsWith(".cerebrum.com");
	} catch {
		return false;
	}
};
